/** @format */
import {SensorGroupColorType} from 'types';

import {SensorChecks, SensorGroupsList, SensorsList} from './types';

/**
 * Внутри detailed сортируем сенсоры по значению и удаляем нулевые значения.
 * @param sensorsList
 */

const sortDetailed = (sensorsList: SensorsList): SensorsList => {
  const processedEntries = Object.entries(sensorsList).map(([sensorId, groupsList]) => {
    const processedGroups: SensorGroupsList = {};
    const groupEntries = Object.entries(groupsList) as [SensorGroupColorType, SensorChecks][];

    groupEntries.forEach(([group, checks]) => {
      if (checks.detailed) {
        const processedDetailed = checks.detailed
          .filter(sensor => sensor.value !== 0)
          .sort((a, b) => b.value - a.value);
        processedGroups[group] = {
          ...checks,
          detailed: processedDetailed,
        };
      } else {
        processedGroups[group] = checks;
      }
    });

    return [sensorId, processedGroups];
  });

  return Object.fromEntries(processedEntries);
};

export {sortDetailed};
